<template>
    <div class="drawer-search">
        <font-awesome-icon
            class="drawer-search__icon"
            :icon="['fal', 'search']"
            size="lg"
        />

        <input
            class="drawer-search__input"
            type="search"
            :value="value"
            @focus="isFocused = true"
            @blur="isFocused = false"
            @keyup="onKeyup"
        >
    </div>
</template>

<script>
export default {
    name: 'search',

    props: {
        location: {
            type: String,
            default: '/',
        },

        value: {
            type: String,
            default: '',
        },
    },

    data() {
        return {
            isFocused: false,
        };
    },

    methods: {
        onKeyup(e) {
            this.$emit('input', e.target.value);
        },
    },
};
</script>

<style lang="scss">
.drawer-search {
    $this: &;

    display: flex;
    align-items: center;
    width: 100%;
    max-width: 250px;
    border-bottom: 1px solid white;

    &__icon {
        font-size: 18px;
        pointer-events: none;
    }

    &__input {
        flex: 1;
        padding: 4px 15px;
        background-color: transparent;

        // removes the 'x' icon from Chromium' search fields:
        // TODO: do we want to make these global?
        &::-webkit-search-decoration,
        &::-webkit-search-cancel-button,
        &::-webkit-search-results-button,
        &::-webkit-search-results-decoration {
            display: none;
        }
    }
}
</style>
